import script from "./TabDisbursementHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabDisbursementHistory.vue?vue&type=script&setup=true&lang=ts"

import "./TabDisbursementHistory.vue?vue&type=style&index=0&id=2341d2e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2341d2e6"]])

export default __exports__